import { api } from "@/lib/orgApi";

export async function getPxCodeSystem() {
  const { data } = await api.get("/px-master/code-system");
  return data;
}

export async function listPxCodeSystems() {
  const { data } = await api.get("/px-master/code-systems");
  return data;
}

export async function listPxValueSets() {
  const { data } = await api.get("/px-master/value-sets");
  return data;
}

export async function listPxMaster({ q, active = true, context, sort } = {}) {
  const params = {};
  if (q) params.q = q;
  if (active != null) params.active = active;
  if (context) params.context = context;
  if (sort) params.sort = sort;
  const { data } = await api.get("/px-master", { params });
  return data;
}

export async function getPxConcept(id) {
  const { data } = await api.get(`/px-master/${encodeURIComponent(id)}`);
  return data;
}

export async function listPxQuickEntry(context = "surgical-history-quick-entry") {
  const { data } = await api.get("/px-master/quick-entry", { params: { context } });
  return data;
}

export async function createPxConcept(payload) {
  const { data } = await api.post("/px-master", payload);
  return data;
}

export async function updatePxConcept(id, payload) {
  const { data } = await api.put(`/px-master/${encodeURIComponent(id)}`, payload);
  return data;
}

export async function setPxConceptActive(id, active) {
  const path = active ? "activate" : "deactivate";
  const { data } = await api.post(`/px-master/${encodeURIComponent(id)}/${path}`);
  return data;
}
